/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BadgeVM { 
    id?: number | null;
    name?: string | null;
    description?: string | null;
    criteria?: string | null;
    imageName?: string | null;
    url?: string | null;
}

